var _rect, _rect2, _rect3, _rect4, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCornerRibbons = function SvgCornerRibbons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 194,
    viewBox: "0 0 194 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.1616,
    y: 27.0908,
    width: 37.0713,
    height: 12.5472,
    fill: "#A03227"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 156.742,
    y: 27.0908,
    width: 37.0713,
    height: 12.5472,
    fill: "#013E58"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2773,
    y: 193.627,
    width: 43.9153,
    height: 12.5472,
    transform: "rotate(-90 27.2773 193.627)",
    fill: "#013F59"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.2773,
    y: 124.047,
    width: 43.9153,
    height: 12.5472,
    transform: "rotate(-90 27.2773 124.047)",
    fill: "#982F26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2772 124.047L27.2772 70.4357L70.6224 27.0908L124.233 27.0908L27.2772 124.047Z",
    fill: "url(#paint0_linear_3733_11883)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2772 193.627L27.2772 139.445L140.202 27.0907L193.813 27.0907L27.2772 193.627Z",
    fill: "url(#paint1_linear_3733_11883)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3733_11883",
    x1: 18.8722,
    y1: 115.642,
    x2: 117.257,
    y2: 13.1613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C03C2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#BB3A2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#AF362A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#9A3026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#7D2720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#581C18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B1312"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3733_11883",
    x1: 21.9222,
    y1: 188.272,
    x2: 172.447,
    y2: 6.50007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007896"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000017"
  })))));
};
export default SvgCornerRibbons;